import moment from 'moment';

const AgeHelper = {
    calculateAge: (dateOfBirth, ageAsOfDate, dateFormat = 'YYYY-MM-DD') => {
        const momentDateOfBirth = moment(dateOfBirth, dateFormat);
        const momentAgeAsOf = moment(ageAsOfDate, dateFormat);
        if (!momentDateOfBirth.isValid() || !momentAgeAsOf.isValid()) {
            return 0;
        }
        return momentAgeAsOf.diff(momentDateOfBirth, 'years');
    },
    isMinor: dateOfBirth => {
        return dateOfBirth
            ? AgeHelper.calculateAge(
                  dateOfBirth,
                  moment().format('YYYY-MM-DD')
              ) < 16
            : false;
    }
};

export default AgeHelper;
